import React, { useEffect, useRef } from 'react';
import c from 'classnames';
import { useSelector } from 'react-redux';

import type { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { SearchPromotedContentThemes } from '../../../components';
import { SEARCHKIT_PROMOTED_CONTENT_THEMES_FACET_PILLAR } from '../../../config/constants';
import type { ImmutableTaxonomyTheme } from '../../../types/taxonomy';

import './style.scss';

interface ParagraphThemeContentOverviewProps {
  theme?: ImmutableTaxonomyTheme;
}

const ParagraphThemeContentOverview: React.FC<ParagraphThemeContentOverviewProps> = ({ theme }) => {
  const searchRef = useRef<HTMLDivElement>(null);
  const searchParams = useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['router', 'location', 'search'], ''));

  const themeJS = theme?.toJS();
  const themeId = themeJS?.tid[0].value;
  const showSubjects = themeJS?.field_show_subjects?.[0]?.value || false;
  const classNames = c('Paragraph', 'ParagraphThemeContentOverview');

  // Scroll to the search content when we enter the page with a pillar facet value set.
  useEffect(() => {
    if (!searchRef.current) {
      return;
    }

    if (!searchParams.includes(SEARCHKIT_PROMOTED_CONTENT_THEMES_FACET_PILLAR)) {
      return;
    }

    searchRef.current.scrollIntoView();
  // We disable this linting rule, because we only want
  // to scroll to the search content on mount.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classNames}>
      <Container>
        <div className="row">
          <div ref={searchRef} className="col-12">
            <SearchPromotedContentThemes theme={themeId} showSubjects={showSubjects}>
              <SearchPromotedContentThemes.Facets className="ParagraphThemeContentOverview__options">
                <SearchPromotedContentThemes.PillarFacet />

                <div className="ParagraphThemeContentOverview__facets">
                  <SearchPromotedContentThemes.AdvancedFacets />

                  <div className="ParagraphThemeContentOverview__sort">
                    <SearchPromotedContentThemes.Stats />
                  </div>
                </div>
              </SearchPromotedContentThemes.Facets>

              <SearchPromotedContentThemes.Results />
            </SearchPromotedContentThemes>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphThemeContentOverview;
